<template>
    <div>
    <div>
        <div class="input-row">
            <!-- FIRST NAME -->
            <div class="field-state input-folder">
                <div class="input-folder--input">
                    <PrimeInputText
                        v-model="first_name" 
                        @input="emit('addressChanged')"
                        type="text" 
                        :id="`first_name_${componentId}`" 
                        placeholder=" " 
                        :class="{
                            'invalid-state-input': props.errors.first_name != null
                        }"
                        required 
                        aria-label="Enter your first name or company name"
                        :readonly="!props.canEdit"
                        autocomplete="false"
                        maxlength="48"
                    />
                    <label :for="`first_name_${componentId}`">
                        <p class="paragraph-default">First Name / Company *</p>
                    </label>
                </div>
                <p class="input-support-text invalid-state">{{ props.errors.first_name }}</p>
            </div>
        </div>
        <div class="input-row">
            <!-- LAST NAME -->
            <div class="field-state input-folder">
                <div class="input-folder--input">
                    <PrimeInputText
                        v-model="last_name" 
                        @input="emit('addressChanged')"
                        type="text" 
                        :id="`last_name_${componentId}`" 
                        placeholder=" " 
                        required 
                        :class="{
                            'invalid-state-input': props.errors.last_name != null
                        }"
                        aria-label="Enter your last name"
                        :readonly="!props.canEdit"
                        autocomplete="false"
                        maxlength="48"
                    />
                    <label :for="`last_name_${componentId}`">
                        <p class="paragraph-default">Last Name</p>
                    </label>
                </div>
                <p class="input-support-text invalid-state">{{ props.errors.last_name }}</p>
            </div>
        </div>

        <!-- STREET 1 -->
        <div class="field-state input-folder">
            <div class="input-folder--input">
                <PrimeInputText
                    v-model="street1"
                    @input="emit('addressChanged')" 
                    type="text" 
                    :id="`street1_${componentId}`" 
                    placeholder=" " 
                    :class="{
                        'invalid-state-input': props.errors.street1 != null
                    }"
                    required 
                    aria-label="Enter your address"
                    :readonly="!props.canEdit"
                    autocomplete="false"
                    name="street1"
                    maxlength="48"
                />
                <label :for="`street1_${componentId}`">
                    <p class="paragraph-default">Address *</p>
                </label>
            </div>
            <p class="input-support-text invalid-state">{{ props.errors.street1 }}</p>
        </div>

        <!-- STREET 2 -->
        <div class="field-state input-folder">
            <div class="input-folder--input">
                <PrimeInputText
                    v-model="street2"
                    @input="emit('addressChanged')" 
                    type="text" 
                    :id="`street2_${componentId}`" 
                    placeholder=" " 
                    :class="{
                        'invalid-state-input': props.errors.street2 != null
                    }"
                    required 
                    aria-label="Enter your address"
                    :readonly="!props.canEdit"
                    autocomplete="false"
                    name="street2"
                    maxlength="48"
                />
                <label :for="`street2_${componentId}`">
                    <p class="paragraph-default">Address 2</p>
                </label>
            </div>
            <p class="input-support-text invalid-state">{{ props.errors.street2 }}</p>
        </div>

        <!-- STREET 3 -->
        <div class="field-state input-folder">
            <div class="input-folder--input">
                <PrimeInputText
                    v-model="street3"
                    @input="emit('addressChanged')" 
                    type="text" 
                    :id="`street3_${componentId}`" 
                    placeholder=" " 
                    required 
                    :class="{
                        'invalid-state-input': props.errors.street3 != null
                    }"
                    aria-label="Enter your address"
                    :readonly="!props.canEdit"
                    autocomplete="false"
                    name="street3"
                    maxlength="48"
                />
                <label :for="`street3_${componentId}`">
                    <p class="paragraph-default">Address 3</p>
                </label>
            </div>
            <p class="input-support-text invalid-state">{{ props.errors.street3 }}</p>
        </div>

        <div class="input-row">
            <!-- CITY -->
            <div class="field-state input-folder">
                <div class="input-folder--input">
                    <PrimeInputText
                        v-model="city"
                        @input="emit('addressChanged')" 
                        type="text" 
                        :id="`city_${componentId}`" 
                        placeholder=" " 
                        :class="{
                            'invalid-state-input': props.errors.city != null
                        }"
                        required 
                        aria-label="Enter your city"
                        :readonly="!props.canEdit"
                        autocomplete="false"
                        name="city"
                        maxlength="30"
                    />
                    <label :for="`city_${componentId}`">
                        <p class="paragraph-default">City *</p>
                    </label>
                </div>
                <p class="input-support-text invalid-state">{{ props.errors.city }}</p>
            </div>

            <!-- STATE -->
            <div class="field-state input-folder">
                <custom-select
                    v-model="selectedRegion"
                    label="State *"
                    name="state" 
                    :id="`state_${componentId}`"
                    :class="{
                        'invalid-state-input': props.errors.state != null
                    }"
                    aria-label="Enter your state"
                    :readonly="!props.canEdit"
                    :options="formattedRegions"
                />
                <div class="field-state input-folder"><p class="input-support-text invalid-state">{{ props.errors.state }}</p></div>
            </div>
        </div>

        <div class="input-row">
            <!-- POSTAL CODE -->
            <div class="field-state input-folder country-input">
                <div class="input-folder--input">
                    <PrimeInputText
                        v-model="zip"
                        @input="emit('addressChanged')" 
                        type="text" 
                        :id="`zip_${componentId}`" 
                        placeholder=" " 
                        :class="{
                            'invalid-state-input': props.errors.zip != null
                        }"
                        required 
                        aria-label="Enter your postal or ZIP code"
                        :readonly="!props.canEdit"
                        autocomplete="false"
                        name="zip"
                        maxlength="12"
                    />
                    <label :for="`zip_${componentId}`">
                        <p class="paragraph-default">Postal Code</p>
                    </label>
                </div>
                <p class="input-support-text invalid-state">{{ props.errors.zip }}</p>
            </div>

            <!-- COUNTRY -->
            <div class="selectore-state select-wrapper">
                <custom-select
                    v-model="selectedCountry"
                    label="Country *"
                    name="country" 
                    :id="`country_${componentId}`"
                    :class="{
                        'invalid-state-input': props.errors.country != null
                    }"
                    aria-label="Enter your country"
                    :readonly="!props.canEdit"
                    :options="formattedCountries"
                />
                <div class="field-state input-folder"><p class="input-support-text invalid-state">{{ props.errors.country }}</p></div>
            </div>
        </div>

        <div class="input-row">
            <!-- PHONE -->
            <div class="field-state input-folder">
                <div class="input-folder--input">
                    <PrimeInputMask
                        v-model="phone"
                        @input="emit('addressChanged')" 
                        type="text" 
                        required 
                        aria-label="Enter your phone number"
                        :readonly="!props.canEdit"
                        :class="{
                            'invalid-state-input': props.errors.phone != null
                        }"
                        autocomplete="false"
                        name="phone"
                        maxlength="12"
                        mask="(999) 999-9999"
                        :pt="{
                            pcInputText: {
                                id:`phone_${componentId}`
                            }
                        }"
                    />
                    <label :for="`phone_${componentId}`" >
                        <p class="paragraph-default">Phone</p>
                    </label>
                </div>
                <p class="input-support-text invalid-state">{{ props.errors.phone }}</p>
            </div>
        </div>
    </div>

    <div v-if="validationEnabled">
        <p v-if="!isValid && isFullAddress" class="paragraph-default">
            The address you entered is invalid. Please enter a valid address.
        </p>
        <p v-else-if="isValid && isDifferent && isFullAddress" class="paragraph-default">
            <a class="text-link" @click="openSuggestedAddressModal()">
                Use Suggested Address
            </a>
        </p>
    </div>
    </div>
</template>
<script setup lang="ts">
    import type { PropType } from "vue";
    import { ref, computed, toRef } from "vue";
    import { useAddressValidation } from "@/helpers/composables/useAddressValidation";
    import SuggestedAddressModal from "@/components/SuggestedAddressModal.vue";
    import { useDialog } from "primevue/usedialog";
    import { v4 as uuidv4 } from "uuid";

    interface Country {
        alpha2code: string;
        alpha3code: string;
        name: string;
    }

    interface Region {
        code: string;
        name: string;
    }

    const componentId = ref(uuidv4());

    const emit = defineEmits(["addressChanged"]);
    let first_name = defineModel("first_name", { default: "" });
    let last_name = defineModel("last_name", { default: "" });
    let inCareOf = defineModel("inCareOf", { default: "" });
    let street1 = defineModel("street1", { default: "" });
    let street2 = defineModel("street2", { default: "" });
    let street3 = defineModel("street3", { default: "" });
    let city = defineModel("city", { default: "" });
    let state = defineModel("state", { default: "" });
    let zip = defineModel("zip", { default: "" });
    let country = defineModel("country", { default: "USA" });
    let phone = defineModel("phone", { default: "" });

    let props = defineProps({
        canEdit: {
            type: Boolean,
            default: true
        },
        regions: {
            type: Array as PropType<Region[]>,
            default: () => []
        },
        countries: {
            type: Array as PropType<Country[]>,
            default: () => [
                {alpha2code: 'US', alpha3code: 'USA', name: 'United States'}
            ]
        },
        errors: {
            type: Object,
            default: () => {
                return {};
            }
        },
        enableValidation: {
            type: Boolean,
            default: false
        }
    });

    let dialog = useDialog();

    const openSuggestedAddressModal = () => {
        dialog.open(SuggestedAddressModal, {
            props: {
                modal: true,
                showHeader: false
            },
            data: {
                oldAddress: currentAddress.value,
                newAddress: suggestedAddress.value,
            },
            onClose: (props) => {
                if(props?.data?.useSuggestedAddress){
                    useSuggestedAddress();
                }
            }
        });
    };

    let isEnabled = toRef(props, "enableValidation");

    let isFullAddress = computed(()=>{
        return street1.value != null && street1.value != '' &&
        city.value != null && city.value != '' &&
        state.value != null && state.value != '' &&
        zip.value != null && zip.value != '' &&
        country.value != null && country.value != '';
    })

    let { isValid, isDifferent, isLoadingValidation, validationEnabled, validAddress } =
        useAddressValidation(
            {
                street1,
                street2,
                city,
                state,
                postal_code: zip,
                country: country
            },
            isEnabled
        );

    let currentAddress = computed(() => {
        return {
            name: name.value,
            inCareOf: inCareOf.value,
            street1: street1.value,
            street2: street2.value,
            street3: street3.value,
            city: city.value,
            state: state.value,
            zip: zip.value,
            country: country.value
        };
    });

    let suggestedAddress = computed(() => {
        return {
            ...currentAddress.value,
            street1: validAddress.value.street1
                ? validAddress.value.street1
                : currentAddress.value.street1,
            street2: validAddress.value.street2
                ? validAddress.value.street2
                : currentAddress.value.street2,
            city: validAddress.value.city
                ? validAddress.value.city
                : currentAddress.value.city,
            state: validAddress.value.state
                ? validAddress.value.state
                : currentAddress.value.state,
            zip: validAddress.value.postal_code
                ? validAddress.value.postal_code
                : currentAddress.value.zip,
            country: validAddress.value.country
                ? validAddress.value.country
                : currentAddress.value.country
        };
    });

    let useSuggestedAddress = () => {
        street1.value = suggestedAddress.value.street1;
        street2.value = suggestedAddress.value.street2;
        city.value = suggestedAddress.value.city;
        state.value = suggestedAddress.value.state;
        zip.value = suggestedAddress.value.zip;
        country.value = suggestedAddress.value.country;
    };

    let selectedRegion = computed({
        get(){
            return formattedRegions.value.find(region=>region.key == state.value);
        },
        set(value){
            state.value = value.key;
        }
    })
    let formattedRegions = computed(() => {
        return props.regions.map((region) => {
            return {
                key: region.code,
                value: region.code
            };
        });
    });

    let selectedCountry = computed({
        get(){
            return formattedCountries.value.find(country=>country.key == country.value);
        },
        set(value){
            country.value = value.key;
        }
    })
    let formattedCountries = computed(() => {
        return props.countries.map((country) => {
            return {
                key: country.alpha3code,
                value: country.alpha3code
            };
        });
    });  
</script>
